import axios from "axios";
import API_URL from "../../constant/api.config";
import { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { hideLoading, showLoading } from "../../actions/loaderAction";
import { getMyInquiries, isOpenInquiry } from "../../actions/inquiryAction";
import ReactPaginate from "react-paginate";
import MyInquiriesFilter from "./MyInquiriesFilter";
import SubHeader from "../../components/SubHeader";
import Emitter from "../../utils/Emitter";
import MediumPopup from "../../components/MediumPopup";
import { getCountryList } from "../../actions/defaultDataAction";
import { useAuth } from "../../AuthProvider";
import {
  setAuthHeaders,
  showErrorMessage,
  showSuccessMessage,
  convertUTCToTzDate,
  buildPath,
} from "../../utils/common";
import { ToastContainer } from "react-toastify";
import axiosHttp from "../../axiosHttp";
import errorMessages from "../../constant/errorMessages";
import { capitalize, debounce, find, isArray, isEmpty, map, size, trim } from "lodash";
import moment from "moment";
import { Link } from "react-router-dom";
import NoDataFound from "../../components/common/NoDataFound";
import ToolipsCustom from "../../components/ToolipsCustom";
import { privateRoutePaths } from "@/routes/private.route.config";
import roles from "@/constant/roles.config";
import axiosInstance from "@/axiosHttp";
import defaultValues from "@/constant/defaultValues";
import { useNavigate } from "react-router-dom";

const MyRecivedInquiry = (props) => {
  const { IMAGE_PATH } = defaultValues;
  const PATH = IMAGE_PATH.BASE_URL;

  const nav = useNavigate();

  const {
    user,
    isSuperAdmin,
    trade_mode_type,
    isPreKYCUser,
    isDemoUser,
    isViewer,
    isEndUser,
    company_plan,
  } = useAuth();
  const [allInquiries, setAllInquiries] = useState([]);
  const [pagination, setPagination] = useState([]);
  const [limit, setLimit] = useState(6);
  const [current_page, setCurrentPage] = useState(1);
  const [searchFilterObj, setSearchFilterObj] = useState({
    filter_val0: null,
    findWhom0: "All",
    selected_country0: null,
    startDate0: null,
    endDate0: null,
  });
  const [tableKey, setTableKey] = useState(0);

  const initialRef = useRef(true);
  const [mediummodalShow, setMediumModalShow] = useState(false);
  const [selectedInquiry, setSelectedInquiry] = useState(null);

  const [countryList, setCountryList] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);

  const [companyList, setCompanyList] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const headers = setAuthHeaders();

  const [formData, setFormData] = useState({
    country_assign: "",
    company: "",
  });
  const [errors, setErrors] = useState({});
  const [isButtonDisabled, setisButtonDisabled] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [upgradePlanShow, setUpgradePlanShow] = useState(false);

  const showPickupAddress = [
    "EXW (Ex-Works or Ex-Warehouse)",
    "FCA (Free to Carrier)",
  ];
  const showDeliveryAddress = [
    "CPT (Carriage Paid To)",
    "CIP (Carriage And Insurance Paid To)",
    "DAP (Delivered At Place)",
    "DDP (Delivered Duty Paid)",
  ];

  const getPrefix = () => {
    if (user && isPreKYCUser) return roles.PRE_KYC.prefix;
    if (user && isDemoUser) return roles.DEMO.prefix;
    if (user && isEndUser) return roles.END_USER.prefix;
    if (user && isViewer) return roles.VIEWER.prefix;
    return roles.SUPER_ADMIN.prefix;
  };

  const getMyInquiries = async (limit, current_page, filterObj) => {
    await props.showLoading();
    await props
      .getMyInquiries(limit, current_page, filterObj)
      .then((response) => {
        setAllInquiries(response.data);
        setPagination(response.pagination);
      })
      .catch((err) => {
        console.log("Error ==== ", err);
        showErrorMessage("Something Went Wrong!!");
      });
    await props.hideLoading();
  };

  const [itemOffset, setItemOffset] = useState(0);

  const endOffset = itemOffset + limit;
  // const currentItems = allInquiries.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(pagination.total / limit);

  const handlePageClick = (event) => {
    getMyInquiries(limit, event.selected + 1, searchFilterObj);
    // const newOffset = (event.selected * limit) % allInquiries.length;
    // setItemOffset(newOffset);
  };

  const setInquiriesFilters = (newState) => {
    props.showLoading();
    newState.table_search = "";
    newState.current_page = 1;
    setCurrentPage(1);
  };

  const filterApplyOnInquiries = (filterObj) => {
    setSearchFilterObj(filterObj);
    getMyInquiries(limit, current_page, filterObj);
    setTableKey((prev) => prev + 1);
    props.hideLoading();
  };

  useEffect(() => {
    getMyInquiries(limit, current_page, searchFilterObj);
  }, []);

  const safeParse = (data) => {
    if (!data) return "-";
    if (typeof data !== "string") return data; // If it's already an array, object, or number, return it directly
    try {
      return JSON.parse(data);
    } catch (e) {
      return data; // Fallback to raw string if it's not valid JSON
    }
  };

  const handlePopupShow = (inquiry) => {
    if (inquiry.freight_type == "Air") {
      const parsedLwh = safeParse(inquiry.lwh);
      const parsedContainers = safeParse(inquiry.no_of_containers);
      const parsedCbpp = safeParse(inquiry.cbpp);

      let lwh_noqty_cbpp = [];

      if (isArray(parsedLwh)) {
        for (let i = 0; i < parsedLwh.length; i++) {
          lwh_noqty_cbpp.push({
            lwh: parsedLwh[i],
            // Fallback to value if matching index doesn't exist or parsedContainers isn't an array
            no_qty: Array.isArray(parsedContainers)
              ? parsedContainers[i]
              : parsedContainers,
            cbpp: Array.isArray(parsedCbpp) ? parsedCbpp[i] : parsedCbpp,
          });
        }
        inquiry.lwh_qty_cbpp = lwh_noqty_cbpp;
      } else {
        inquiry.lwh_qty_cbpp = [
          {
            lwh: parsedLwh,
            no_qty: parsedContainers,
            cbpp: parsedCbpp,
          },
        ];
      }
    }

    setSelectedInquiry(inquiry);
    setMediumModalShow(true);
    if (inquiry.assign_to === null) {
      setIsChecked(true);
      setSelectedCompany(null);
      setFormData((prevalue) => {
        return {
          ...prevalue,
          company: "",
        };
      });
    } else {
      setIsChecked(false);
      setSelectedCompany(null);
      setSelectedCountry(null);
      setFormData((prevalue) => {
        return {
          ...prevalue,
          company: "",
          country_assign: "",
        };
      });
    }
    inqShowStatus(inquiry);
    setErrors({});
  };

  const inqShowStatus = async (inquiry) => {
    try {
      const response = await props.inqShowId(inquiry.id);
      console.log("DATAT ---------", response);
    } catch (err) {
      console.log("Error ==== ", err);
    } finally {
      console.log("finally call fun ==== ");
    }
  };

  const handleCountryChange = async (cval) => {
    setSelectedCompany(null);
    setSelectedCountry(cval);
    const countryId = cval.label;

    let country = "";
    let inquiry_for = "";
    if (selectedInquiry) {
      let type = selectedInquiry.type;
      if (type === "Logistic_Partner") {
        country = selectedInquiry.country_to;
        inquiry_for = "LOG_PTR";
      }
      if (type === "Supplier") {
        country = selectedInquiry.country;
        inquiry_for = "SUPPLIER";
      }
    }

    setFormData((prevalue) => {
      return {
        ...prevalue,
        country_assign: countryId,
      };
    });

    await axiosHttp
      .post(
        API_URL + "/get-company",
        { country: countryId, inquiry_for: inquiry_for, search: "NO" },
        {
          headers,
        },
      )
      .then((response) => {
        if (response.status === 200) {
          if (response.data.status === true) {
            const options = response.data.data.map((ct) => ({
              value: ct.id,
              label: ct.company_name,
            }));
            setCompanyList(options);
          }
        }
      })
      .catch((err) => {
        console.log("Error ============= ", err);
      });
  };

  const handleCompanyChange = (cval) => {
    setSelectedCompany(cval);
    let companyId = cval.value;

    setFormData((prevalue) => {
      return {
        ...prevalue,
        company: companyId,
      };
    });
  };

  const fetchCountries = async () => {
    await props
      .getCountryList()
      .then((data) => {
        const options = data.map((country) => ({
          value: country.id,
          label: country.name,
          countryCode: country.iso2,
        }));
        setCountryList(options);
      })
      .catch((err) => {
        console.log("Error >>>> ", err);
      });
  };

  useEffect(() => {
    Emitter.on("FILTER_INQUIRIES0", filterApplyOnInquiries);
    Emitter.on("SET_FILTER_INQUIRIES0", setInquiriesFilters);
    return () => {
      Emitter.off("FILTER_INQUIRIES0", filterApplyOnInquiries);
    };
  });

  useEffect(() => {
    fetchCountries();
  }, []);

  useEffect(() => {
    if (selectedInquiry) {
      setCompanyAndCountry(selectedInquiry);
    }
  }, [selectedInquiry]);

  const setCompanyAndCountry = async (selectedInquiry) => {
    let country = "";
    let inquiry_for = "";
    if (selectedInquiry) {
      let type = selectedInquiry.type;
      if (type === "Logistic_Partner") {
        country = selectedInquiry.country_to;
        inquiry_for = "LOG_PTR";
      }
      if (type === "Supplier") {
        country = selectedInquiry.country;
        inquiry_for = "SUPPLIER";
      }
    }

    if (selectedInquiry.assign_to == null) {
      setIsChecked(true);

      const normalizedCountry = country.trim().toLowerCase();
      const selectedCountryOption = countryList.find(
        (option) => option.label.toLowerCase().trim() === normalizedCountry,
      );

      if (selectedCountryOption) {
        setSelectedCountry(selectedCountryOption);
      }

      setFormData((prevalue) => {
        return {
          ...prevalue,
          country_assign: country,
        };
      });
      await axiosHttp
        .post(
          API_URL + "/get-company",
          { country: country, inquiry_for: inquiry_for, search: "NO" },
          {
            headers,
          },
        )
        .then((response) => {
          if (response.status === 200) {
            if (response.data.status === true) {
              const options = response.data.data.map((ct) => ({
                value: ct.id,
                label: ct.company_name,
              }));
              setCompanyList(options);
            }
          }
        })
        .catch((err) => {
          console.log("Error ============= ", err);
        });
    }
  };

  const handleInputChange = (newValue) => {
    if (newValue !== "" && selectedInquiry && selectedCountry) {
      let inquiry_for = "";
      if (selectedInquiry) {
        let type = selectedInquiry.type;
        if (type === "Logistic_Partner") {
          inquiry_for = "LOG_PTR";
        }
        if (type === "Supplier") {
          inquiry_for = "SUPPLIER";
        }
      }

      if (newValue.length >= 3) {
        setCompanyList([]);
        axiosHttp
          .post(
            API_URL + "/get-company",
            {
              search_txt: newValue,
              country: selectedCountry.value,
              inquiry_for: inquiry_for,
              search: "YES",
            },
            { headers },
          )
          .then((response) => {
            if (response.status === 200) {
              if (response.data.status === true) {
                if (!isEmpty(response.data.data)) {
                  const options = response.data.data.map((ct) => ({
                    value: ct.id,
                    label: ct.company_name,
                  }));
                  setCompanyList(options);
                } else {
                  axiosHttp
                    .post(
                      API_URL + "/get-company",
                      {
                        country: selectedCountry.label,
                        inquiry_for: inquiry_for,
                        search: "NO",
                      },
                      {
                        headers,
                      },
                    )
                    .then((response) => {
                      if (response.status === 200) {
                        if (response.data.status === true) {
                          const options = response.data.data.map((ct) => ({
                            value: ct.id,
                            label: ct.company_name,
                          }));
                          setCompanyList(options);
                        }
                      }
                    })
                    .catch((err) => {
                      console.log("Error ============= ", err);
                    });
                }
              }
            }
          });
      }
      // else {
      //   setCompanyList([]);
      //   setSelectedCompany(null);
      //   setCompanyAndCountry(selectedInquiry);
      // }
    }
  };

  const handleCancelClick = (e) => {
    e.preventDefault();
    setMediumModalShow(false);
  };

  const validation = () => {
    let er = { ...errors };
    let isValid = true;

    if (formData.country_assign === "") {
      isValid = false;
      er.country_assign = errorMessages.FIELD_REQUIRED;
    } else {
      er.country_assign = "";
    }

    if (formData.company === "") {
      isValid = false;
      er.company = errorMessages.FIELD_REQUIRED;
    } else {
      er.company = "";
    }

    setErrors(er);

    if (!isValid) {
      return false;
    }

    return true;
  };

  const handleInquirySubmit = async (e) => {
    e.preventDefault();

    if (validation()) {
      try {
        setisButtonDisabled(true);
        await axiosHttp
          .post(
            API_URL + "/assign-company-inquiry",
            { formData, selectedInquiry: selectedInquiry },
            {
              headers,
            },
          )
          .then((response) => {
            if (response.data.status === true) {
              getMyInquiries(limit, current_page, searchFilterObj);
              setTimeout(() => {
                setisButtonDisabled(false);
                setMediumModalShow(false);
              }, 1000);
              showSuccessMessage("Inquiry Assign Successfully!");
            } else {
              setisButtonDisabled(false);
              setErrors({});
              const errors = {};
              if (response.data.error.country_assign) {
                errors.country_assign = response.data.error.country_assign;
              }
              if (response.data.error.company) {
                errors.company = response.data.error.company;
              }

              setErrors(errors);
              return Object.keys(errors).length > 0;
            }
          })
          .catch((error) => {
            setisButtonDisabled(false);
            console.error("Error fetching data:", error);
          });
      } catch (err) {
        console.error(err);
      }
    }
  };

  const styleError = {
    display: "block",
  };

  const handleCheckChange = () => {
    setIsChecked(!isChecked);
    if (isChecked === false) {
      setIsChecked(true);
      setSelectedCompany(null);
      setSelectedCountry(null);
      setErrors({});
      if (selectedCountry === null) {
        setCompanyList([]);
      }
      setFormData((prevalue) => {
        return {
          ...prevalue,
          company: "",
          country_assign: "",
        };
      });
    }
  };

  const createPlanRequest = async () => {
    let data = {
      member_id: user.member_id,
    };

    const headers = setAuthHeaders();
    const response = await axiosInstance.post(
      API_URL + "/member/upgrade-plan-request",
      data,
      {
        headers,
      },
    );
    if (response) {
      if (response.data) {
        setUpgradePlanShow(false);
        if (user.trade_mode_type !== "SUPPLIER") {
          showSuccessMessage(
            "We have received your upgrade request. Our team will contact you soon.",
          );
        } else {
          setTimeout(() => {
            nav(
              `/${getPrefix(user)}${buildPath(privateRoutePaths.ADMIN_CHOOSE_PLAN, { id: user.member_id })}`,
            );
          }, 500);
        }
      }
    }
  };

  const handleupgradePlan = () => {
    setMediumModalShow(false);
    if (trade_mode_type !== "SUPPLIER") {
      setUpgradePlanShow(true);
    } else {
      createPlanRequest();
    }
  };

  useEffect(() => {
    if (selectedCountry === null) {
      setCompanyList([]);
    }
  }, [selectedCountry]);

  const handleDownload = (filename) => {
    const link = document.createElement("a");
    link.href = filename;
    link.download = filename;
    link.target = "_blank";
    link.click();
  };

  return (
    <>
      <div className="send-receive-inquiry">
        <MyInquiriesFilter />

        <div className="row my-4">
          {allInquiries &&
            allInquiries.map((inquiry) => (
              // <div className="col-md-4 mb-4 g-4">
              //   <div className="card mb-6">
              //     <div className="card-body">
              //       <h5 className="card-title mb-1">
              //         Company Name : {inquiry.company_name}
              //       </h5>
              //       <p className="card-text">Email : {inquiry.email}</p>
              //       <p className="card-text">
              //         Contact Person : {inquiry.contact_person}
              //       </p>
              //       <p className="card-text">Type : {inquiry.type}</p>
              //       <p className="card-text">
              //         Phone No. : {inquiry.phone}
              //       </p>
              //       <p className="card-text">
              //         Remarks : {inquiry.message}
              //       </p>
              //     </div>
              //   </div>
              // </div>

              <div class=" col-xxl-4 col-xl-6 col-lg-6 col-md-12 inquiry-box-main">
                <div
                  class={
                    "card shadow " +
                    (isSuperAdmin
                      ? "inquiry-box-wraper"
                      : "user-inquiry-box-wraper")
                  }
                >
                  <div class="card-body ">
                    <div class="inquiry-box-heading">
                      <div className="inquiry-card-heading">
                        <h4>{inquiry.company_name}</h4>
                        <div className="d-flex justify-content-between">
                          <p className="text-muted">
                            {(inquiry?.country_to || inquiry?.country_from) && (
                              <svg
                                version="1.1"
                                id="fi_747340"
                                x="0px"
                                y="0px"
                                viewBox="0 0 512 512"
                                height={"18px"}
                                width={"18px"}
                                fill="#585858"
                              >
                                <g>
                                  <g>
                                    <path
                                      d="M256,110.062c-52.412,0-95.053,42.641-95.053,95.053s42.641,95.053,95.053,95.053s95.053-42.641,95.053-95.053
                                        S308.413,110.062,256,110.062z M256,260.146c-30.344,0-55.031-24.687-55.031-55.031s24.687-55.031,55.031-55.031
                                        s55.031,24.687,55.031,55.031S286.344,260.146,256,260.146z"
                                    ></path>
                                  </g>
                                </g>
                                <g>
                                  <g>
                                    <path
                                      d="M256,0C142.899,0,50.885,92.015,50.885,205.115v5.67c0,57.2,32.794,123.856,97.474,198.113
                                        c46.888,53.832,93.121,91.368,95.065,92.94L256,512l12.576-10.161c1.945-1.572,48.178-39.108,95.065-92.94
                                        c64.679-74.258,97.474-140.913,97.474-198.113v-5.67C461.115,92.015,369.101,0,256,0z M421.093,210.786
                                        c0,96.665-124.551,213.68-165.093,249.202C215.447,424.455,90.907,307.444,90.907,210.786v-5.67
                                        c0-91.032,74.061-165.093,165.093-165.093s165.093,74.061,165.093,165.093V210.786z"
                                    ></path>
                                  </g>
                                </g>
                              </svg>
                            )}

                            <span className="mx-1">
                              {inquiry.type == "Supplier"
                                ? inquiry.country
                                : inquiry.country_to || inquiry.country_from}
                            </span>
                          </p>
                          <span className="mx-1 text-muted">
                            Inquiry ID:
                            <span className="mx-1 text-orex-id">
                              {" "}
                              {inquiry.inquiry_unique_id}
                            </span>
                          </span>
                        </div>
                      </div>
                    </div>

                    <div className="inquiry-box-content">
                      <p class="d-flex align-items-center gap-2 mt-2">
                        <svg
                          version="1.1"
                          id="fi_266134"
                          x="0px"
                          y="0px"
                          viewBox="0 0 512 512"
                          height={"18px"}
                          width={"18px"}
                          fill="#585858"
                        >
                          <g>
                            <g>
                              <path
                                d="M333.187,237.405c32.761-23.893,54.095-62.561,54.095-106.123C387.282,58.893,328.389,0,256,0
                                S124.718,58.893,124.718,131.282c0,43.562,21.333,82.23,54.095,106.123C97.373,268.57,39.385,347.531,39.385,439.795
                                c0,39.814,32.391,72.205,72.205,72.205H400.41c39.814,0,72.205-32.391,72.205-72.205
                                C472.615,347.531,414.627,268.57,333.187,237.405z M164.103,131.282c0-50.672,41.225-91.897,91.897-91.897
                                s91.897,41.225,91.897,91.897S306.672,223.18,256,223.18S164.103,181.954,164.103,131.282z M400.41,472.615H111.59
                                c-18.097,0-32.82-14.723-32.82-32.821c0-97.726,79.504-177.231,177.231-177.231s177.231,79.504,177.231,177.231
                                C433.231,457.892,418.508,472.615,400.41,472.615z"
                              ></path>
                            </g>
                          </g>
                        </svg>

                        {inquiry.contact_person}
                      </p>
                      <p class="d-flex align-items-center gap-2 mt-2">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          id="fi_2907765"
                          data-name="Layer 1"
                          viewBox="0 0 24 24"
                          width="18"
                          height="18"
                          fill="#585858"
                        >
                          <path d="M20,19.75H4A2.76,2.76,0,0,1,1.25,17V7A2.76,2.76,0,0,1,4,4.25H20A2.76,2.76,0,0,1,22.75,7V17A2.76,2.76,0,0,1,20,19.75ZM4,5.75A1.25,1.25,0,0,0,2.75,7V17A1.25,1.25,0,0,0,4,18.25H20A1.25,1.25,0,0,0,21.25,17V7A1.25,1.25,0,0,0,20,5.75Z"></path>
                          <path d="M12,13.35a3.25,3.25,0,0,1-1.65-.45L1.62,7.71a.76.76,0,0,1-.27-1,.74.74,0,0,1,1-.26l8.74,5.18a1.69,1.69,0,0,0,1.76,0l8.74-5.18a.74.74,0,0,1,1,.26.76.76,0,0,1-.27,1L13.65,12.9A3.25,3.25,0,0,1,12,13.35Z"></path>
                        </svg>
                        {inquiry.email}
                      </p>
                      <p class="d-flex align-items-center gap-2 my-2">
                        <svg
                          height="18"
                          viewBox="-106 0 469 469.33333"
                          width="18"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="#585858"
                          id="fi_1551230"
                        >
                          <path d="m206.246094 0h-156.160156c-27.558594.03125-49.890626 22.363281-49.917969 49.921875v369.492187c.027343 27.558594 22.359375 49.890626 49.917969 49.917969h156.160156c27.558594-.027343 49.890625-22.359375 49.921875-49.917969v-369.492187c-.03125-27.558594-22.363281-49.890625-49.921875-49.921875zm28.585937 419.414062c-.015625 15.78125-12.804687 28.570313-28.585937 28.585938h-156.160156c-15.78125-.015625-28.570313-12.804688-28.585938-28.585938v-369.492187c.015625-15.785156 12.804688-28.574219 28.585938-28.589844h156.160156c15.78125.015625 28.570312 12.804688 28.585937 28.589844zm0 0"></path>
                          <path d="m160.167969 42.667969h-64c-5.890625 0-10.667969 4.773437-10.667969 10.664062s4.777344 10.667969 10.667969 10.667969h64c5.890625 0 10.664062-4.777344 10.664062-10.667969s-4.773437-10.664062-10.664062-10.664062zm0 0"></path>
                          <path d="m149.5 405.332031c0 11.785157-9.550781 21.335938-21.332031 21.335938-11.785157 0-21.335938-9.550781-21.335938-21.335938 0-11.78125 9.550781-21.332031 21.335938-21.332031 11.78125 0 21.332031 9.550781 21.332031 21.332031zm0 0"></path>
                        </svg>

                        {inquiry.phone ? inquiry.phone : "-"}
                      </p>

                      {isSuperAdmin && (
                        <div className="py-2 inquiry-assign">
                          {inquiry.assign_to > 0 ? (
                            <>
                              <div className="d-flex align-items-center my-2">
                                <h4 class="badge bg-success text-light py-1 px-2">
                                  Assigned To
                                </h4>
                                <span className="ms-2">
                                  {inquiry.company?.company_name}
                                </span>
                              </div>

                              <div className="d-flex align-items-center">
                                <h4 class="badge bg-success from text-light py-1 px-2">
                                  Assigned From
                                </h4>
                                <span className="ms-2">
                                  {inquiry.company_name}
                                </span>
                              </div>
                            </>
                          ) : (
                            <span className=" badge bg-danger">
                              Not Assigned
                            </span>
                          )}
                        </div>
                      )}

                      <div className="py-2 inquiry-assign">
                        {inquiry.created_at ? (
                          <>
                            <div className="d-flex align-items-center">
                              <strong>Created At</strong>
                              <span className="ms-2">
                                {convertUTCToTzDate(
                                  inquiry.created_at,
                                  "Etc/UTC",
                                  "YYYY-MM-DD hh:mm A",
                                )}
                                <ToolipsCustom
                                  subtitle="Universal Time Coordinated"
                                  title={"UTC"}
                                ></ToolipsCustom>
                              </span>
                            </div>
                          </>
                        ) : (
                          <></>
                        )}
                      </div>
                    </div>
                  </div>

                  <div class="card-footer border-top d-flex align-items-center justify-content-between">
                    <p class="inquiry-supplier">
                      {inquiry.type && trim(inquiry.type) === "Logistic_Partner"
                        ? "Logistic Partner"
                        : inquiry.type}

                      {/* {trade_mode_type === 'LOG_PTR' ? (
                                    'Supplier'
                                  ) : (
                                    inquiry.type && inquiry.type.trim() === 'Logistic_Partner'
                                      ? 'Logistic Partner'
                                      : inquiry.type
                                  )} */}
                    </p>
                    <button
                      type="button"
                      onClick={() => handlePopupShow(inquiry)}
                      className="btn-regi"
                    >
                      View Inquiry Details
                    </button>
                  </div>
                </div>
              </div>
            ))}

          {isEmpty(allInquiries) && (
            <div className="me-5">
              <div className=" col-12 bg-white shadow rounded border-0 pt-4">
                <NoDataFound />
              </div>
            </div>
          )}
        </div>

        <div className="d-flex justify-content-between inquiry-pagination">
          {pagination.total > 0 && (
            <>
              <p>
                showing <b>{pagination.from}</b> to <b>{pagination.to}</b> of{" "}
                <b>{pagination.total}</b>
              </p>

              <ReactPaginate
                key={tableKey}
                nextLabel=">"
                onPageChange={handlePageClick}
                pageRangeDisplayed={2}
                marginPagesDisplayed={2}
                pageCount={pageCount}
                previousLabel="<"
                pageClassName="page-item"
                pageLinkClassName="page-link"
                previousClassName="page-item"
                previousLinkClassName="page-link"
                nextClassName="page-item"
                nextLinkClassName="page-link"
                breakLabel="..."
                breakClassName="page-item"
                breakLinkClassName="page-link"
                containerClassName="pagination"
                activeClassName="active"
                renderOnZeroPageCount={null}
              />
            </>
          )}
        </div>
      </div>

      {/* 
      {inquiry.type && inquiry.type === "Logistic_Partner"
                      ? "Logistic Partner"
                      : inquiry.type} */}
      {/* {console.log(`inpuqry_stauts===> ${selectedInquiry.type}`)} */}

      <MediumPopup
        // title={`Inquiry Details - ${
        //   selectedInquiry ? selectedInquiry.company_name : ""
        // } - ${
        //   selectedInquiry && selectedInquiry.type == "Supplier"
        //     ? "(Supplier)"
        //     : "(Logistic Partner)"
        // }`}
        title={`Inquiry Details - ${
          selectedInquiry && selectedInquiry.type == "Supplier"
            ? "(Supplier)"
            : "(Logistic Partner)"
        }`}
        // title="Inquiry Details"
        mediummodalShow={mediummodalShow}
        setMediumModalShow={setMediumModalShow}
        // closeButtonLabel="Cancel"
        // okButtonLabel="Submit"
        // onSubmit={handleInquirySubmit}
      >
        <form onSubmit={handleInquirySubmit}>
          {selectedInquiry && (
            <div className="inquiry-details-popup">
              <div className="row g-0 justify-content-between inquiry-details-content mt-2">
                {selectedInquiry && selectedInquiry.company?.company_name && (
                  <div className="row ge-3 p-0 col-xl-6 col-lg-6 border inquiry-to-box">
                    <div className="col-xl-12 p-0 inquiry-to">
                      <p>To</p>
                    </div>

                    <div className="col-xl-12 gx-4">
                      <div>
                        <p className="inquiry-detials-info">
                          {" "}
                          <b>Company Name:</b>{" "}
                          {selectedInquiry.company?.company_name &&
                          selectedInquiry.assign_to ? (
                            <Link
                              to={`/${getPrefix()}${buildPath(
                                privateRoutePaths.VIEW_COMPANY_PROFILE,
                                {
                                  id: selectedInquiry.assign_to,
                                },
                              )}`}
                              target="_blank"
                            >
                              {" "}
                              {selectedInquiry.company?.company_name}
                            </Link>
                          ) : (
                            <span>{selectedInquiry.company?.company_name}</span>
                          )}{" "}
                        </p>
                      </div>
                    </div>

                    <div className="col-xl-12 gx-4">
                      <div>
                        <p>
                          {" "}
                          <b>Contact Person:</b>{" "}
                          {selectedInquiry.company?.salutation}{" "}
                          {selectedInquiry.company?.first_name}{" "}
                          {selectedInquiry.company?.last_name}{" "}
                        </p>
                      </div>
                    </div>

                    <div className="col-xl-12 gx-4">
                      <div>
                        <p>
                          {" "}
                          <b>Email:</b> {selectedInquiry.company?.email}{" "}
                        </p>
                      </div>
                    </div>

                    <div className="col-xl-12 gx-4">
                      <div>
                        <p className="border-0">
                          {" "}
                          <b>Phone:</b>{" "}
                          {selectedInquiry.company?.phone
                            ? selectedInquiry.company?.phone
                            : " - "}{" "}
                        </p>
                      </div>
                    </div>
                  </div>
                )}

                {selectedInquiry && selectedInquiry.company_name && (
                  <div className="row gs-3 p-0 col-xl-6 col-lg-6 border inquiry-from-box">
                    <div className="col-xl-12 p-0 inquiry-from">
                      <p>From</p>
                    </div>

                    <div className="col-xl-12 gx-4">
                      <div>
                        <p className="inquiry-detials-info">
                          {" "}
                          <b>Company Name:</b>{" "}
                          {selectedInquiry.company_name &&
                          selectedInquiry.assign_from ? (
                            <Link
                              to={`/${getPrefix()}${buildPath(
                                privateRoutePaths.VIEW_COMPANY_PROFILE,
                                {
                                  id: selectedInquiry.assign_from,
                                },
                              )}`}
                              target="_blank"
                            >
                              {" "}
                              {selectedInquiry.company_name}
                            </Link>
                          ) : (
                            <span>{selectedInquiry.company_name}</span>
                          )}{" "}
                        </p>
                      </div>
                    </div>

                    <div className="col-xl-12 gx-4">
                      <div>
                        <p>
                          {" "}
                          <b>Contact Person:</b>{" "}
                          {!isEmpty(selectedInquiry.contact_person)
                            ? selectedInquiry.contact_person
                            : " - "}{" "}
                        </p>
                      </div>
                    </div>

                    <div className="col-xl-12 gx-4">
                      <div>
                        <p>
                          {" "}
                          <b>Email: </b>
                          {!isEmpty(selectedInquiry.email)
                            ? selectedInquiry.email
                            : " - "}{" "}
                        </p>
                      </div>
                    </div>

                    <div className="col-xl-12 gx-4">
                      <div>
                        <p className="border-0">
                          <b>Phone Number:</b>{" "}
                          {!isEmpty(selectedInquiry.phone)
                            ? selectedInquiry.phone
                            : " - "}{" "}
                        </p>
                      </div>
                    </div>
                  </div>
                )}
              </div>

              <div className="row g-0 justify-content-between border g-0 my-3 inquiry-information-box">
                <div className="col-xl-12 p-0 inquiry-information text-center">
                  <p>Inquiry information</p>
                </div>

                {selectedInquiry.type === "Supplier" && (
                  <>
                    <div className="col-xl-6 gx-4">
                      <div>
                        <p>
                          {" "}
                          <b>Industry:</b>{" "}
                          {!isEmpty(selectedInquiry.industry)
                            ? selectedInquiry.industry
                            : " - "}{" "}
                        </p>
                      </div>
                    </div>

                    <div className="col-xl-6 gx-4">
                      <div>
                        <p>
                          {" "}
                          <b>Country:</b>{" "}
                          {!isEmpty(selectedInquiry.country)
                            ? selectedInquiry.country
                            : " - "}{" "}
                        </p>
                      </div>
                    </div>

                    <div className="col-xl-6 gx-4">
                      <div>
                        <p>
                          {" "}
                          <b>Product:</b>{" "}
                          {!isEmpty(selectedInquiry.product)
                            ? selectedInquiry.product
                            : " - "}{" "}
                        </p>
                      </div>
                    </div>

                    <div className="col-xl-6 gx-4">
                      <div>
                        <p>
                          {" "}
                          <b>Quantity:</b>{" "}
                          {!isEmpty(selectedInquiry.quantity)
                            ? selectedInquiry.quantity
                            : " - "}{" "}
                        </p>
                      </div>
                    </div>

                    <div className="col-xl-6 gx-4">
                      <div>
                        <p>
                          {" "}
                          <b>Unit:</b>{" "}
                          {!isEmpty(selectedInquiry.unit)
                            ? selectedInquiry.unit
                            : " - "}{" "}
                        </p>
                      </div>
                    </div>
                    <div className="col-xl-6 gx-4">
                      <div>
                        <p>
                          {" "}
                          <b>Inquiry ID:</b>{" "}
                          {!isEmpty(selectedInquiry.inquiry_unique_id)
                            ? selectedInquiry.inquiry_unique_id
                            : " - "}{" "}
                        </p>
                      </div>
                    </div>

                    <div className="col-xl-12 gx-4 ck-massage ck-edit-cntnt">
                      {!isEmpty(selectedInquiry.message) &&
                        selectedInquiry.message !== "lock" && (
                          <div
                            className="border-0"
                            dangerouslySetInnerHTML={{
                              __html: `<p className="border-0" style="border-bottom: 0px solid #f3f3f3 !important"><b>Message:</b>${!isEmpty(selectedInquiry.message) ? selectedInquiry.message : " - "}</p> `,
                            }}
                          />
                        )}
                      {!isEmpty(selectedInquiry.message) &&
                        selectedInquiry.message == "lock" && (
                          <div className="lock-box">
                            {" "}
                            <div
                              className="lock-button"
                              onClick={handleupgradePlan}
                            >
                              {" "}
                              <i class="fa-solid fa-lock"></i> Upgrade Plan{" "}
                            </div>{" "}
                          </div>
                        )}
                    </div>
                  </>
                )}

                {selectedInquiry.type === "Logistic_Partner" && (
                  <>
                    {selectedInquiry.freight_type == "Air" && (
                      <>
                        <div className="col-xl-6 gx-4">
                          <div>
                            <p>
                              <b>Freight type:</b>{" "}
                              {!isEmpty(selectedInquiry.freight_type)
                                ? selectedInquiry.freight_type
                                : " - "}
                            </p>
                          </div>
                        </div>
                        <div className="col-xl-6 gx-4"></div>
                        <div className="col-xl-6 gx-4">
                          <div>
                            <p>
                              {" "}
                              <b>Origin Country:</b>
                              {!isEmpty(selectedInquiry.country_from)
                                ? selectedInquiry.country_from
                                : " - "}
                            </p>
                          </div>
                        </div>
                        <div className="col-xl-6 gx-4">
                          <div>
                            <p>
                              <b>Origin Airport:</b>
                              {!isEmpty(selectedInquiry.port_of_origin)
                                ? selectedInquiry.port_of_origin
                                : " - "}
                            </p>
                          </div>
                        </div>
                        <div className="col-xl-6 gx-4">
                          <div>
                            <p>
                              <b>Destination Country:</b>
                              {!isEmpty(selectedInquiry.country_to)
                                ? selectedInquiry.country_to
                                : " - "}
                            </p>
                          </div>
                        </div>

                        <div className="col-xl-6 gx-4">
                          <div>
                            <p>
                              <b>
                                {selectedInquiry.freight_type === "Air"
                                  ? "Air"
                                  : "Port"}{" "}
                                of destination:
                              </b>{" "}
                              {!isEmpty(selectedInquiry.port_of_destination)
                                ? selectedInquiry.port_of_destination
                                : " - "}
                            </p>
                          </div>
                        </div>

                        <div className="col-xl-6 gx-4">
                          <p className="border-bottom-0">
                            <b>Commodity/Product:</b>{" "}
                            {!isEmpty(selectedInquiry.commodity)
                              ? selectedInquiry.commodity
                              : " - "}{" "}
                          </p>
                        </div>

                        <div className="col-xl-6 gx-4">
                          <p className="border-bottom-0">
                            <b>HS Code:</b> {selectedInquiry.hs_code}{" "}
                          </p>
                        </div>

                        {/* {!isEmpty(selectedInquiry.lwh_qty_cbpp) &&
                          map(selectedInquiry.lwh_qty_cbpp, (val) => {
                            return (
                              <p>
                                {val.lwh} {val.no_qty} {val.cbpp}
                              </p>
                            );
                          })}
                        {isEmpty(selectedInquiry.lwh_qty_cbpp) && (
                          <>
                            <div className="col-xl-6 gx-4">
                              <p>
                                <b>Length/Width/Height (CM):</b>{" "}
                                {selectedInquiry.lwh}{" "}
                              </p>
                            </div>
                            <div className="col-xl-6 gx-4">
                              <p>
                                <b>Containers Type/Boxes/Pallat/Packages:</b>{" "}
                                {selectedInquiry.cbpp}{" "}
                              </p>
                            </div>
                          </>
                        )} */}
                        <div className="col-xl-12 gx-4 mt-4">
                                                  <div className="air-table-wrap">
                                                    <table className="air-table">
                                                      <thead>
                                                        <tr>
                                                          <th>Length/Width/Height (CM)</th>
                                                          <th>No/Qty</th>
                                                          <th>Type of Packaging</th>
                                                        </tr>
                                                      </thead>
                                                      <tbody>
                                                        {!isEmpty(selectedInquiry.lwh_qty_cbpp) &&
                                                          map(selectedInquiry.lwh_qty_cbpp, (val, index) => {
                                                            return (
                                                              <tr key={index}>
                                                                <td>{val.lwh}</td>
                                                                <td>{val.no_qty}</td>
                                                                <td>{val.cbpp}</td>
                                                              </tr>
                                                            );
                                                          })}
                        
                                                        {isEmpty(selectedInquiry.lwh_qty_cbpp) && (
                                                          <tr>
                                                            <td>
                                                              <b>Length/Width/Height (CM):</b> {selectedInquiry.lwh}
                                                            </td>
                                                            <td></td>
                                                            <td>
                                                              <b>Containers Type/Boxes/Pallat/Packages:</b>{" "}
                                                              {selectedInquiry.cbpp}
                                                            </td>
                                                          </tr>
                                                        )}
                                                      </tbody>
                                                    </table>
                                                  </div>
                                                </div>

                        <div className="col-xl-6 gx-4">
                          <p>
                            <b>Total Weight (KG):</b>{" "}
                            {!isEmpty(selectedInquiry.total_weight)
                              ? selectedInquiry.total_weight
                              : " - "}{" "}
                          </p>
                        </div>

                        <div className="col-xl-6 gx-4">
                          <p>
                            {" "}
                            <b>Term:</b>{" "}
                            {!isEmpty(selectedInquiry.term)
                              ? selectedInquiry.term
                              : " - "}{" "}
                          </p>
                        </div>
                        <div className="col-xl-6 gx-4">
                          <p>
                            {" "}
                            <b>Inquiry ID:</b>{" "}
                            {!isEmpty(selectedInquiry.inquiry_unique_id)
                              ? selectedInquiry.inquiry_unique_id
                              : " - "}{" "}
                          </p>
                        </div>
                        {selectedInquiry &&
                          !isEmpty(selectedInquiry.term) &&
                          showPickupAddress.includes(selectedInquiry.term) && (
                            <div className="col-xl-6 gx-4">
                              <p>
                                {" "}
                                <b>Pickup Address:</b>{" "}
                                {selectedInquiry.pickup_address}{" "}
                              </p>
                            </div>
                          )}
                        {selectedInquiry &&
                          !isEmpty(selectedInquiry.term) &&
                          showDeliveryAddress.includes(
                            selectedInquiry.term,
                          ) && (
                            <div className="col-xl-6 gx-4">
                              <p>
                                {" "}
                                <b>Delivery Address:</b>{" "}
                                {selectedInquiry.delivery_address}{" "}
                              </p>
                            </div>
                          )}
                      </>
                    )}

                    {selectedInquiry.freight_type == "Road" && (
                      <>
                        <div className="col-xl-6 gx-4">
                          <div>
                            <p>
                              <b>Freight type:</b> Road Transportation
                            </p>
                          </div>
                        </div>
                        <div className="col-xl-6 gx-4">
                          <div>
                            <p>
                              <b>Cargo type:</b> {selectedInquiry.ocean_type}{" "}
                              {selectedInquiry.ocean_type == "FTL"
                                ? "(Full Truck Load)"
                                : "(Less Truck Load)"}
                            </p>
                          </div>
                        </div>
                        <div className="col-xl-6 gx-4">
                          <div>
                            <p>
                              <b>Country From:</b>{" "}
                              {selectedInquiry.country_from
                                ? selectedInquiry.country_from
                                : "-"}
                            </p>
                          </div>
                        </div>
                        <div className="col-xl-6 gx-4">
                          <div>
                            <p>
                              <b>Origin Port:</b>{" "}
                              {selectedInquiry.port_of_origin
                                ? selectedInquiry.port_of_origin
                                : "-"}
                            </p>
                          </div>
                        </div>
                        <div className="col-xl-6 gx-4">
                          <div>
                            <p>
                              <b>Country To:</b>{" "}
                              {selectedInquiry.country_to
                                ? selectedInquiry.country_to
                                : "-"}
                            </p>
                          </div>
                        </div>
                        <div className="col-xl-6 gx-4">
                          <div>
                            <p>
                              <b>Destination Port:</b>{" "}
                              {selectedInquiry.port_of_destination
                                ? selectedInquiry.port_of_destination
                                : "-"}
                            </p>
                          </div>
                        </div>
                        <div className="col-xl-6 gx-4">
                          <div>
                            <p>
                              <b>Commodity:</b>{" "}
                              {selectedInquiry.commodity
                                ? selectedInquiry.commodity
                                : "-"}
                            </p>
                          </div>
                        </div>
                        <div className="col-xl-6 gx-4">
                          <div>
                            <p>
                              <b>HS code:</b>{" "}
                              {selectedInquiry.hs_code
                                ? selectedInquiry.hs_code
                                : "-"}
                            </p>
                          </div>
                        </div>
                        <div className="col-xl-6 gx-4">
                          <div>
                            <p>
                              <b>No of Containers/Vehicles:</b>{" "}
                              {selectedInquiry.no_of_containers
                                ? selectedInquiry.no_of_containers
                                : "-"}
                            </p>
                          </div>
                        </div>
                        <div className="col-xl-6 gx-4">
                          <div>
                            <p>
                              <b>Containers Type:</b>{" "}
                              {selectedInquiry.cbpp
                                ? selectedInquiry.cbpp
                                : "-"}
                            </p>
                          </div>
                        </div>
                        <div className="col-xl-6 gx-4">
                          <div>
                            <p>
                              <b>Total Weight:</b>{" "}
                              {selectedInquiry.total_weight
                                ? selectedInquiry.total_weight
                                : "-"}
                            </p>
                          </div>
                        </div>
                        <div className="col-xl-6 gx-4">
                          <div>
                            <p>
                              <b>Term:</b>{" "}
                              {selectedInquiry.term
                                ? selectedInquiry.term
                                : "-"}
                            </p>
                          </div>
                        </div>
                        {!isEmpty(selectedInquiry.term) &&
                          showPickupAddress.includes(selectedInquiry.term) && (
                            <div className="col-xl-6 gx-4">
                              <p>
                                <b>Pickup Address:</b>{" "}
                                {selectedInquiry.pickup_address}
                              </p>
                            </div>
                          )}
                        {((!isEmpty(selectedInquiry.term) &&
                          showDeliveryAddress.includes(selectedInquiry.term)) ||
                          selectedInquiry.freight_type === "DAP") && (
                          <div className="col-xl-6 gx-4">
                            <p>
                              <b>Delivery Address:</b>{" "}
                              {selectedInquiry.delivery_address}
                            </p>
                          </div>
                        )}
                        <div className="col-xl-6 gx-4">
                          <p>
                            {" "}
                            <b>Inquiry ID:</b>{" "}
                            {!isEmpty(selectedInquiry.inquiry_unique_id)
                              ? selectedInquiry.inquiry_unique_id
                              : " - "}{" "}
                          </p>
                        </div>
                      </>
                    )}

                    {selectedInquiry.freight_type == "DAP" && (
                      <>
                        <div className="col-xl-6 gx-4">
                          <div>
                            <p>
                              <b>Freight type:</b> DAP Services
                            </p>
                          </div>
                        </div>
                        <div className="col-xl-6 gx-4">
                          <div>
                            <p>
                              <b>Cargo type:</b> {selectedInquiry.ocean_type == "Project_Cargo" ? "Project Cargo" : (selectedInquiry.ocean_type == "DAG_GOODS") ? "Dangerous Goods" : (selectedInquiry.ocean_type == "LCL_FCL") ? "LCL & FCL Both" : selectedInquiry.ocean_type} {selectedInquiry.ocean_type == "FCL" ? "(Full Container Load)" : ""}
                                {selectedInquiry.ocean_type == "LCL" ? "(Less Container Load)" : ""}
                            </p>
                          </div>
                        </div>
                        <div className="col-xl-6 gx-4">
                          <div>
                            <p>
                              <b>Country:</b> {selectedInquiry.country_from}
                            </p>
                          </div>
                        </div>
                        <div className="col-xl-6 gx-4">
                          <div>
                            <p>
                              <b>Port:</b> {selectedInquiry.port_of_origin}
                            </p>
                          </div>
                        </div>
                        <div className="col-xl-6 gx-4">
                          <div>
                            <p>
                              <b>
                                {selectedInquiry.ocean_type == "Ro-Ro"
                                  ? "Commodity/Product"
                                  : "Commodity"}
                                :
                              </b>{" "}
                              {selectedInquiry.commodity}
                            </p>
                          </div>
                        </div>
                        <div className="col-xl-6 gx-4">
                          <div>
                            <p>
                              <b>Hs Code:</b>{" "}
                              {!isEmpty(selectedInquiry.hs_code)
                                ? `${selectedInquiry.hs_code} `
                                : "-"}
                            </p>
                          </div>
                        </div>
                        <div className="col-xl-6 gx-4">
                          <div>
                            <p>
                              <b>
                                {selectedInquiry.ocean_type == "FCL" ||
                                selectedInquiry.ocean_type == "LCL" ||
                                selectedInquiry.ocean_type == "DAG_GOODS"
                                  ? "No of Containers: "
                                  : ""}
                                {selectedInquiry.ocean_type == "Ro-Ro"
                                  ? "No of Units: "
                                  : ""}
                                {selectedInquiry.ocean_type == "Project_Cargo"
                                  ? "No of Pieces: "
                                  : ""}
                                :
                              </b>{" "}
                              {selectedInquiry.no_of_containers
                                ? selectedInquiry.no_of_containers
                                : "-"}
                            </p>
                          </div>
                        </div>
                        {selectedInquiry.ocean_type != "Ro-Ro" &&
                          selectedInquiry.ocean_type != "Project_Cargo" && (
                            <div className="col-xl-6 gx-4">
                              <div>
                                <p>
                                  <b>
                                    {selectedInquiry.ocean_type ==
                                      "DAG_GOODS" ||
                                    selectedInquiry.ocean_type == "LCL"
                                      ? "Type of Packaging: "
                                      : ""}
                                    {selectedInquiry.ocean_type == "FCL"
                                      ? "Type of Container: "
                                      : ""}
                                    :
                                  </b>{" "}
                                  {selectedInquiry.cbpp && selectedInquiry.cbpp}
                                </p>
                              </div>
                            </div>
                          )}
                        <div className="col-xl-6 gx-4">
                          <div>
                            <p>
                              <b>Total Weight (KG):</b>{" "}
                              {!isEmpty(selectedInquiry.total_weight)
                                ? selectedInquiry.total_weight
                                : " - "}
                            </p>
                          </div>
                        </div>
                        {selectedInquiry.term && (
                          <div className="col-xl-6 gx-4">
                            <p>
                              <b>Term:</b> {selectedInquiry.term}
                            </p>
                          </div>
                        )}
                        {!isEmpty(selectedInquiry.term) &&
                          showPickupAddress.includes(selectedInquiry.term) && (
                            <div className="col-xl-6 gx-4">
                              <p>
                                <b>Pickup Address:</b>{" "}
                                {selectedInquiry.pickup_address}
                              </p>
                            </div>
                          )}
                        {((!isEmpty(selectedInquiry.term) &&
                          showDeliveryAddress.includes(selectedInquiry.term)) ||
                          selectedInquiry.freight_type === "DAP") && (
                          <div className="col-xl-6 gx-4">
                            <p>
                              <b>Delivery Address:</b>{" "}
                              {selectedInquiry.delivery_address}
                            </p>
                          </div>
                        )}
                        <div className="col-xl-6 gx-4">
                          <p>
                            {" "}
                            <b>Inquiry ID:</b>{" "}
                            {!isEmpty(selectedInquiry.inquiry_unique_id)
                              ? selectedInquiry.inquiry_unique_id
                              : " - "}{" "}
                          </p>
                        </div>
                      </>
                    )}

                    {selectedInquiry.freight_type == "Ocean" && (
                      <>
                        <div className="col-xl-6 gx-4">
                          <div>
                            <p>
                              <b>Freight type:</b> Sea Freight
                            </p>
                          </div>
                        </div>
                        <div className="col-xl-6 gx-4">
                          <p>
                            <b>Cargo type:</b>{" "}
                            {selectedInquiry.ocean_type == "Project_Cargo"
                              ? "Project Cargo"
                              : selectedInquiry.ocean_type == "DAG_GOODS"
                                ? "Dangerous Goods"
                                : selectedInquiry.ocean_type == "LCL_FCL"
                                  ? "LCL & FCL Both"
                                  : selectedInquiry.ocean_type}{" "}
                            {selectedInquiry.ocean_type == "FCL"
                              ? "(Full Container Load)"
                              : ""}
                            {selectedInquiry.ocean_type == "LCL"
                              ? "(Less Container Load)"
                              : ""}
                          </p>
                        </div>

                        <div className="col-xl-6 gx-4">
                          <p>
                            <b>Country From:</b> {selectedInquiry.country_from}
                          </p>
                        </div>
                        <div className="col-xl-6 gx-4">
                          <p>
                            <b>Origin Port:</b> {selectedInquiry.port_of_origin}
                          </p>
                        </div>
                        <div className="col-xl-6 gx-4">
                          <p>
                            <b>Country To:</b> {selectedInquiry.country_to}
                          </p>
                        </div>
                        <div className="col-xl-6 gx-4">
                          <p>
                            <b>Destination Port:</b>{" "}
                            {selectedInquiry.port_of_destination}
                          </p>
                        </div>
                        <div className="col-xl-6 gx-4">
                          {selectedInquiry.ocean_type == "Ro-Ro" ||
                          selectedInquiry.ocean_type == "LCL_FCL" ? (
                            <p>
                              <b>Commodity/Product: </b>{" "}
                              {selectedInquiry.commodity}
                            </p>
                          ) : (
                            <p>
                              <b>Commodity: </b> {selectedInquiry.commodity}
                            </p>
                          )}
                        </div>
                        <div className="col-xl-6 gx-4">
                          <p>
                            <b>Hs Code:</b>{" "}
                            {!isEmpty(selectedInquiry.hs_code)
                              ? `${selectedInquiry.hs_code} `
                              : "-"}
                          </p>
                        </div>
                        <div className="col-xl-6 gx-4">
                          <p>
                            <b>
                              {selectedInquiry.ocean_type == "FCL" ||
                              selectedInquiry.ocean_type == "LCL" ||
                              selectedInquiry.ocean_type == "DAG_GOODS"
                                ? "No of Containers: "
                                : ""}
                              {selectedInquiry.ocean_type == "Ro-Ro"
                                ? "No of Units: "
                                : ""}
                              {selectedInquiry.ocean_type == "Project_Cargo"
                                ? "No of Pieces: "
                                : ""}
                              {selectedInquiry.ocean_type == "LCL_FCL"
                                ? "No of Containers: "
                                : ""}
                              {selectedInquiry.ocean_type == "Bulk"
                                ? "Cargo Qty: "
                                : ""}
                            </b>

                            {selectedInquiry.no_of_containers &&
                              selectedInquiry.no_of_containers}
                          </p>
                        </div>
                        {selectedInquiry.ocean_type != "Ro-Ro" && (
                            <div className="col-xl-6 gx-4">
                              <p>
                                <b>
                                  {selectedInquiry.ocean_type == "DAG_GOODS" ||
                                  selectedInquiry.ocean_type == "LCL" || selectedInquiry.ocean_type == "Project_Cargo"
                                    ? "Type of Packaging: "
                                    : ""}
                                  {selectedInquiry.ocean_type == "FCL"
                                    ? "Type of Container: "
                                    : ""}
                                  {selectedInquiry.ocean_type == "LCL_FCL"
                                    ? "Type of packaging/container: "
                                    : ""}
                                  {selectedInquiry.ocean_type == "Bulk"
                                    ? "Type of product: "
                                    : ""}
                                </b>
                                {selectedInquiry.cbpp && selectedInquiry.cbpp}
                              </p>
                            </div>
                          )}
                        <div className="col-xl-6 gx-4">
                          <p>
                            <b>Total Weight (KG):</b>{" "}
                            {!isEmpty(selectedInquiry.total_weight)
                              ? selectedInquiry.total_weight
                              : " - "}
                          </p>
                        </div>
                        <div className="col-xl-6 gx-4">
                          <p>
                            <b>Term:</b> {selectedInquiry.term}
                          </p>
                        </div>
                        {!isEmpty(selectedInquiry.term) &&
                          showPickupAddress.includes(selectedInquiry.term) && (
                            <div className="col-xl-4 gx-4">
                              <p>
                                <b>Pickup Address:</b>{" "}
                                {selectedInquiry.pickup_address}
                              </p>
                            </div>
                          )}
                        {((!isEmpty(selectedInquiry.term) &&
                          showDeliveryAddress.includes(selectedInquiry.term)) ||
                          selectedInquiry.freight_type === "DAP") && (
                          <div className="col-xl-4 gx-4">
                            <p>
                              <b>Delivery Address:</b>{" "}
                              {selectedInquiry.delivery_address}
                            </p>
                          </div>
                        )}
                        <div className="col-xl-6 gx-4">
                          <p>
                            {" "}
                            <b>Inquiry ID:</b>{" "}
                            {!isEmpty(selectedInquiry.inquiry_unique_id)
                              ? selectedInquiry.inquiry_unique_id
                              : " - "}{" "}
                          </p>
                        </div>
                      </>
                    )}

                    {/* <div className="col-xl-12 gx-4 ck-massage ck-edit-cntnt">
                      <div>
                        <div
                          className="border-0"
                          dangerouslySetInnerHTML={{
                            __html: `<p className="border-0" style="border-bottom: 0px solid #f3f3f3 !important"><b>Message:</b> ${!isEmpty(selectedInquiry.message) ? selectedInquiry.message : ' - '}</p>`,
                          }}
                        />
                      </div>
                    </div> */}

                    <div className="col-xl-12 gx-4 ck-massage ck-edit-cntnt">
                      {(!isEmpty(selectedInquiry.message) || selectedInquiry.message == null) &&
                        selectedInquiry.message !== "lock" && (
                          <div
                            className="border-0"
                            dangerouslySetInnerHTML={{
                              __html: `<p className="border-0" style="border-bottom: 0px solid #f3f3f3 !important"><b>Remark:</b>${!isEmpty(selectedInquiry.message) ? selectedInquiry.message : " - "}</p> `,
                            }}
                          />
                        )}
                      {!isEmpty(selectedInquiry.message) &&
                        selectedInquiry.message == "lock" && (
                          <div className="lock-box">
                            {" "}
                            <div
                              className="lock-button"
                              onClick={handleupgradePlan}
                            >
                              {" "}
                              <i class="fa-solid fa-lock"></i> Upgrade Plan{" "}
                            </div>{" "}
                          </div>
                        )}
                    </div>
                  </>
                )}
              </div>

              {(selectedInquiry.doc1 ||
                selectedInquiry.doc2 ||
                selectedInquiry.doc3 ||
                selectedInquiry.doc4 ||
                selectedInquiry.doc5) && (
                <div className="col-xl-12 mt-3 mb-3">
                  <div className="d-flex flex-wrap gap-2 attachment-btn-wrape">
                    {selectedInquiry.doc1 && (
                      <a
                        className="btn btn-primary"
                        onClick={() =>
                          handleDownload(PATH + selectedInquiry.doc1)
                        }
                      >
                        <i className="fa fa-paperclip"></i> Attachment 1
                      </a>
                    )}
                    {selectedInquiry.doc2 && (
                      <a
                        className="btn btn-primary"
                        onClick={() =>
                          handleDownload(PATH + selectedInquiry.doc2)
                        }
                      >
                        <i className="fa fa-paperclip"></i> Attachment 2
                      </a>
                    )}
                    {selectedInquiry.doc3 && (
                      <a
                        className="btn btn-primary"
                        onClick={() =>
                          handleDownload(PATH + selectedInquiry.doc3)
                        }
                      >
                        <i className="fa fa-paperclip"></i> Attachment 3
                      </a>
                    )}
                    {selectedInquiry.doc4 && (
                      <a
                        className="btn btn-primary"
                        onClick={() =>
                          handleDownload(PATH + selectedInquiry.doc4)
                        }
                      >
                        <i className="fa fa-paperclip"></i> Attachment 4
                      </a>
                    )}
                    {selectedInquiry.doc5 && (
                      <a
                        className="btn btn-primary"
                        onClick={() =>
                          handleDownload(PATH + selectedInquiry.doc5)
                        }
                      >
                        <i className="fa fa-paperclip"></i> Attachment 5
                      </a>
                    )}
                  </div>
                </div>
              )}
            </div>
          )}
        </form>
      </MediumPopup>

      <MediumPopup
        title={"Unlock More with an Upgrade!"}
        mediummodalShow={upgradePlanShow}
        setMediumModalShow={setUpgradePlanShow}
        titlePosition="center-align-title"
        closeButtonLabel="Maybe Later"
        okButtonLabel="Request Upgrade"
        onSubmit={createPlanRequest}
      >
        <p>
          You're currently on a <b> Trial/Free Plan </b>, which has limited
          access.
        </p>
        <p>
          Upgrade your plan to continue using all features without restrictions.
        </p>
        <p>What you will get?</p>
        <ul className="icon">
          <li>Raise unlimited inquiries</li>
          <li>Connect with verified suppliers</li>
          <li>Access complete business features</li>
          <li>Priority support</li>
        </ul>
      </MediumPopup>
      {/* {!isPreKYCUser && company_plan !== null && company_plan !== 'Trial' &&
        <ToastContainer />
       } */}
    </>
  );
};

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    getMyInquiries: (limit, current_page, filterObj) =>
      dispatch(getMyInquiries(limit, current_page, filterObj)),
    showLoading: () => dispatch(showLoading()),
    hideLoading: () => dispatch(hideLoading()),
    getCountryList: () => dispatch(getCountryList()),
    inqShowId: (inqDetailId) => dispatch(isOpenInquiry(inqDetailId)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MyRecivedInquiry);
